import { FileUploadOptions } from "@schoolbelle/api/file";



export const mockFileList:Array<[File, FileUploadOptions]> = [
    [blobToFile(new Blob([JSON.stringify({foo:'bar'}, null, 2)], {type : 'application/json'}), 'test1.json'), {upload_id:1}]
    ,[blobToFile(new Blob(['foo is bar'], {type : 'text/plain'}), 'test2.txt'), {upload_id:2}]
];

function blobToFile (theBlob: Blob, fileName:string): File {
    var b: any = theBlob;
    //A Blob() is almost a File() - it's just missing the two properties below which we will add
    b.lastModifiedDate = new Date();
    b.name = fileName;

    //Cast to a File() type
    return <File>theBlob;
}